/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconClovers: {
  name: 'clovers';
  data: string;
} = {
  name: 'clovers',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M387.783 243.987c-4.159 0-8.162.528-12.168 1.098 11.667-14.924 18.802-33.779 18.802-54.198 0-48.597-38.784-87.379-87.378-87.382-48.594.003-88.482 38.785-88.482 87.382 0 20.246 7.305 39.326 18.802 54.198-3.661-.458-7.278-1.098-11.062-1.098-48.597 0-88.488 39.889-88.488 88.488s39.891 88.488 88.488 88.488c19.828 0 38.136-6.656 52.868-17.799l-44.4 106.332 143.421-.009-45.056-107.898c15.064 12.049 34.075 19.374 54.652 19.374 48.601 0 87.384-39.889 87.384-88.488s-38.786-88.488-87.383-88.488z"/></svg>`,
};
